<top-navig display="true" [hidden]="hidetopnav" [displayFilter]="true" [displayLogo]="false" title="Carte"
    (openFilterEv)="openModal(template)"></top-navig>
<div class=" mp-48" [class.mp-97]="ourApp">
    <div id="scrolling-wrapper" #scrollTap [hidden]="router.isActive('/carte/menus',false)">
        <a *ngIf="displayBestSales" [routerLink]="'/carte/top-des-ventes'" class="card"
            [class.activeTab]="router.isActive('/carte/top-des-ventes',false)">
            <img class="img" src="assets/imgs/topvente.png" alt="top de vente">
            <p>TOP VENTE</p>
        </a>
        <a [routerLink]="'/carte/offers'" *ngIf="displayBestOffers" class="card"
            [class.activeTab]="router.isActive('/carte/offers',false)">
            <img class="img" src="assets/imgs/offers.png" alt="offres">
            <p>OFFRES</p>
        </a>
        <a class="card" [routerLink]="'/carte/menus/'+menucategories[0].slug "
            [class.activeTab]="router.isActive('/carte/menus/'+menucategories[0].slug,false)"
            *ngIf="menucategories.length>0">
            <img class="img" src="assets/imgs/menu.png" alt="menus">
            <p>MENUS</p>
        </a> 
        <ng-container *ngFor="let family of families;let i=index">
            <a class="card" 
                [routerLink]="'/carte/famille/'+family.slug"
                [class.activeTab]="router.isActive('/carte/famille/'+family.slug,false)">
                <img class="img" [src]="family.avatar|absolutePath :'families'" [alt]="family.label">
                <p> {{family.label}}</p>
            </a>
        </ng-container>

    </div>
    <div id="scrolling-wrapper2" #scrollTap2 [hidden]="router.url.indexOf('menus')==-1">
        <a class="back" [routerLink]="'/carte/famille/'+families[0]?.slug">
            <img src="assets/imgs/arrow-menu.png" width="17px" alt="arrow-menu">
        </a> <a class="card" [routerLink]="'/carte/menus/'+menu.slug" *ngFor="let menu of menucategories;let i=index"
            [class.activeTab]="router.isActive('/carte/menus/'+menu.slug,false)">
            <img class="img" [src]="menu.avatar|absolutePath :'families'" [alt]="menu.name">
            <p> {{menu.name}}</p>
        </a>
    </div>
    <router-outlet></router-outlet>
</div>
<div *ngIf="!siteClose" class="btn-cart" [class.addRubberBand]="animation" (click)="toBasket()">
    <img src="assets/imgs/basket.png" width="30px" alt="basket" class="img">
    <div>{{elementsNbr}}</div>
</div>
<ng-template #template>
    <div class="modal-header">
        <input #myInput class="search" type="text" placeholder=" Chercher..." (input)="filterComp(myInput.value)">
    </div>
    <div class="modal-body">
        <label class="container" *ngFor="let c of compositions;let i=index">{{c.text}}
            <input type="checkbox" value="{{c.id}}" [(ngModel)]="c.checked">
            <span class="checkmark"></span>
        </label>
    </div>
    <div class="modal-footer">
        <button class="button-footer" type="button" (click)="search()">
            Valider
        </button>
    </div>
</ng-template>
<ng-template #template2>
    <div class="modal-header navbar-default">
        <button type="button" class="navbar-toggle" (click)="modalRef.hide()">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
        </button>
        <h4 class="modal-title">Menu</h4>
    </div>
    <div class="modal-body">

    </div>
</ng-template>